const config = {
  i18nFallbackApiUrl: process.env.REACT_APP_I18N_API_URL ?? '',
  defaultLang: process.env.REACT_APP_DEFAULT_LANG ?? 'en',
};

export default config;
